import "./style.scss";
import React from "react";
import { NavLink } from "react-router-dom";
const Accordian = (props) => {
  const { title, collapse_Content, index, active, handleToggle } = props;
  const isActive = index == active;
  return (
    <div
      className={
        isActive ? "accordian_container collapse_open" : "accordian_container"
      }
    >
      <section className="accordian_heading">
        <div
          className="accordian_heading_wrapper"
          onClick={() => {
            handleToggle(index);
          }}
        >
          <p >{title}</p>
          <span className={`${ isActive ? "acc_arrow rotate" : "acc_arrow"}`}>
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 13L7 7L1 1"
                stroke="#3B3F4C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </section>

      <section
        className="accordian_collapse"
        style={isActive ? { height: "fit-content" } : { height: "0px" }}
      >
        <ul className="accoidian_collapse_content">
          {collapse_Content &&
            collapse_Content.map((content, i) => {
              return (
                <li key={i}>
                  <NavLink>
                    <div className="li_wrapper">
                      {" "}
                      <span>{content}</span>{" "}
                      <span>
                        <svg
                          width="11"
                          height="10"
                          viewBox="0 0 11 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.7628 1.29852C10.7904 0.968294 10.545 0.678284 10.2147 0.650765L4.83339 0.20232C4.50316 0.174801 4.21315 0.420194 4.18563 0.75042C4.15811 1.08065 4.40351 1.37066 4.73373 1.39817L9.51715 1.79679L9.11853 6.58021C9.09102 6.91044 9.33641 7.20045 9.66664 7.22797C9.99686 7.25549 10.2869 7.01009 10.3144 6.67987L10.7628 1.29852ZM1.39184 9.45803L10.5525 1.70672L9.77734 0.790661L0.616707 8.54197L1.39184 9.45803Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </div>{" "}
                  </NavLink>
                </li>
              );
            })}
        </ul>
      </section>
    </div>
  );
};

export default Accordian;
